import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getVideo } from './redux/actions';
import { videoProgress, completeVideo } from '../redux/actions';
import { selectCurrentEpisode, selectList, selectCurrentShow } from './redux/selectors';
import VideoPlayer from '../../common/video/VideoPlayer';
import Loading from '../../common/components/Loading';

class Episode extends Component {
  static propTypes = {
    shows: PropTypes.array,
    episode: PropTypes.object,
    episodes: PropTypes.array,
    episodesLoaded: PropTypes.bool.isRequired,
    video: PropTypes.object,
    videoLoaded: PropTypes.bool.isRequired,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const params = this.props.match.params;
    this.props.dispatch(getVideo(params.showId, params.episodeId));
  }

  componentWillUpdate(nextProps) {
    const params = this.props.match.params;
    const nextParams = nextProps.match.params;
    if (params.showId !== nextParams.showId || params.episodeId !== nextParams.episodeId) {
      this.props.dispatch(getVideo(nextParams.showId, nextParams.episodeId));
    }
  }

  handleProgress = currentTime => {
    this.props.dispatch(videoProgress(this.props.video.get('id'), currentTime));
  };

  handleEnd = () => {
    const { episode, episodes, match, history } = this.props;
    const episodeIndex = episodes.findIndex(ep => ep.id === episode.id);
    const showId = match.params.showId;

    this.handleProgress(episode.video.duration);
    this.props.dispatch(completeVideo(episode.video.id));

    if (episodeIndex >= 0 && episodes[episodeIndex + 1]) {
      history.push(`/subscription/tv/${showId}/${episodes[episodeIndex + 1].id}?autoplay`);
    } else {
      history.push(`/subscription/tv/${showId}`);
    }
  };

  render() {
    const { videoLoaded, video, location, episode, episodesLoaded, show } = this.props;

    if (!videoLoaded || !episodesLoaded) {
      return <Loading />;
    }

    const fromFavorites = location.state && location.state.fromFavorites;

    return (
      <div className="fullscreen__video-player__wrapper">
        <VideoPlayer
          autoplay={location.search === '?autoplay'}
          title={episode.name}
          poster={episode.image.location}
          onProgress={this.handleProgress}
          onEnd={this.handleEnd}
          backText={fromFavorites ? 'Back to Favorites' : `Back to ${show.name}`}
          backTo={fromFavorites ? '/subscription/library/favorites' : `/subscription/tv/${show.id}`}
          video={video}
          sendToIntercom
          intercomEventName={'watched_tv'}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  show: selectCurrentShow(state.subscription.tv.shows, props.match.params.showId),
  episodesLoaded: state.subscription.tv.episodes.get('loaded'),
  episodes: selectList(state.subscription.tv.episodes),
  episode: selectCurrentEpisode(state.subscription.tv.episodes, props.match.params.episodeId),
  videoLoaded: state.subscription.tv.video.get('loaded'),
  video: state.subscription.tv.video.get('data'),
});

export default connect(mapStateToProps)(Episode);



// WEBPACK FOOTER //
// ./src/subscription/tv/Episode.js